import { _ } from "../../../core/polyglot/polyglot.js";
import { formatAsShortDate } from "../../../core/helpers/date-formatting-util.js";
import { formatCurrency } from "../../../core/helpers/currency-formatting-util.js";
import companyChartLegendItemWidget from "./companyChartLegendItemWidget.js";
import percentage from "../../../core/percentage.js";
import popoverWidget from "../../../core/widgets/popoverWidget/popoverWidget.js";

/**
 * Company legend item for the liabilities.
 * The different items in the company chart legend have different color and pop overs. So that is why we need this.
 */
function companyChartLiabilitiesLegendItemWidget(spec, my) {
	spec ||= {};
	my ||= {};

	spec = Object.assign(spec, {
		title: _("Liabilities"),
		legendItemClass: "legend-item-liabilities",
		seriesId: "liabilities",
		valueRenderer: formatCurrency,
	});

	const that = companyChartLegendItemWidget(spec, my);

	my.createPopover = function (companyBalance) {
		const dateString = formatAsShortDate(companyBalance.date);

		return popoverWidget({
			header: function (html) {
				html.span(dateString, ", ", _("Liabilities"));
			},
			content: function (html) {
				const untaxedReservesValue =
					-companyBalance.taxRate * companyBalance.untaxedReserves;
				if (untaxedReservesValue) {
					html.label(
						{ class: "key-val-pair" },
						_("Untaxed reserves ({taxRate})", {
							taxRate: percentage(companyBalance.taxRate),
						}),
						" ",
						html.span(formatCurrency(untaxedReservesValue)),
					);
				}

				html.label(
					{ class: "key-val-pair" },
					_("Long term liabilities"),
					html.span(
						formatCurrency(-companyBalance.longTermLiabilities),
					),
				);

				html.label(
					{ class: "key-val-pair" },
					_("Short term liabilities"),
					html.span(
						formatCurrency(-companyBalance.currentLiabilities),
					),
				);

				html.label(
					{ class: "key-val-pair" },
					_("Sum"),
					html.span(formatCurrency(-companyBalance.totalLiability)),
				);
			},
		});
	};

	return that;
}

export default companyChartLiabilitiesLegendItemWidget;
